(function ($, window, document, undefined) {

Navigation = ( function() {

	function Constructor() {

		this.start = function () {

			$( '.menu-toggle' ).click( function () {
				$( '#header' ).toggleClass( 'open' );
				$( '.nav-bg' ).toggleClass( 'open' );
				$( '.nav-drawer' ).toggleClass( 'open' );
				$( 'body' ).toggleClass( 'toggled' );
			} );

			$( '.nav-drawer a, .nav-drawer .menu-toggle' ).click( function () {
				$( '.nav-bg' ).removeClass( 'open' );
				$( '.nav-drawer' ).removeClass( 'open' );
				$( 'body' ).removeClass( 'toggled' );
			} );

		};

	}
	return new Constructor();

}() );

})(jQuery, window, document);
